import request from '../../../../utils/request';
import { Result } from '../../../../models/general';

/** Mirrors Mowazaf.Server/Controllers/General/DemoPreviewsController.cs `DemoPreviewsStatusView`. */
export interface DemoPreviewsStatusView {
  enabled: boolean;
}

/** GET api/DemoPreviews/Status — the ONLY server call the payroll-controls previews make. Read-only. */
export async function getDemoPreviewsStatus(): Promise<Result<DemoPreviewsStatusView>> {
  const response = await request.get<Result<DemoPreviewsStatusView>>('DemoPreviews/Status');
  return response.data;
}
